// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer___T3h4"};